import { z, ZodType } from "zod";

export const Pageable = <T>(itemType: ZodType<T, any, any>) =>
  z.object({
    content: z.array(itemType),

    number: z.number(),
    size: z.number(),

    totalElements: z.number(),
    totalPages: z.number(),
    first: z.boolean(),
    last: z.boolean(),
    numberOfElements: z.number(),
  });
